module.exports = __webpack_public_path__ + "static/media/food.0d91a64b.svg";